/**
 * Created by anthony on 4/4/14.
 */
taxes.classy.controller({
    name: 'ApplicationsTaxesController',
    inject: ['$scope', '$rootScope', '$sce', '$q', '$timeout', '$modal', '$http', 'SliderService', 'SliderFactory', 
        'ApplicationService', 'authServiceFactory', 'ModelService', 
        'StandardCudFactory', 'FamilyTaxModelService', 'FamilyModelService',
        'FamilyTaxFamilyService', 'TaxEmailModelFactory', 'BinFactory',
        'SchoolModelService', 'PermissionModelService', 'DateService','PdfService'],
    init: function()
    {
        var self = this;
        this.$.$sce = this.$sce;
        this.$.versionNo = versionNo;
        this.$.authServiceFactory = this.authServiceFactory;

        this.$.ApplicationService = this.ApplicationService;
        this.$.DateService = this.DateService;
        this.$.SliderService = this.SliderService;

        this.$.familyNo = this.ApplicationService.getFamilyNo();
        this.$.cYear = this.ApplicationService.getAwardData().app[0].App_Fin_Year;
        this.$.currentTaxes = 0;
        this.$.taxinfo = this.ApplicationService.getFamilyData().familyTax[0];
        this.$.family = this.ApplicationService.getFamilyData().data;
        //this.$.separate(this.$.family[0].taxDocuments);
        this.$.StandardCudService  = new this.StandardCudFactory(this.FamilyTaxModelService, this.FamilyModelService.get(0).familyID, this.FamilyTaxModelService.get(0)[0], this, []);
        //this.$.setRightTaxDiv('notes');
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.taxIndices = [1,2,3,4,5];
        this.$.separate(this.$.family[0].taxDocuments);
        this.$.verifyHide = false;

        // resize tax accordion on window resize
        this.$timeout(function() {
            $(window).on('resize', function(){
                $('#tax-slideout .panel-collapse').css("max-height", $(this).height() - 352 + 'px');
            }).trigger('resize');
        }, 100);
        this.uploadedFiles = [];
        this.$.uploadLoading = false;
    },
    openUpload: function() {
        this.SliderService.pushSlider(new this.SliderFactory('applicationOverview/submodules/taxes/partials/upload', 'Upload', 's', {'class': 'small-medium'}));

        this.$.files = new Array();
    },
    getIframeSrc: function () {
        let domain = this.authServiceFactory.getDomain();
        return this.$sce.trustAsResourceUrl('https://' + domain + '/school_side//app/apTax/scApTaxBarcode.php?familyID=' + this.ApplicationService.getFamilyData().data[0].familyID);
    },
    submit: function(scope, instance, form) {
        instance.options.factor  = .3;
        if (this.$.taxinfo.currentYearAsk === 0) {
            this.$.taxinfo.currentYearVer = 0;
        }
        if (this.$.taxinfo.previousYearAsk === 0) {
            this.$.taxinfo.previousYearVer = 0;
        }
        this.$q.all([
            this.FamilyTaxFamilyService.putLog(this.$.taxinfo),
            this.FamilyTaxFamilyService.putHelper(this.$.taxinfo, {
                taxDocuments: this.combine(this.$.documentarray),
                familyID: this.ApplicationService.getFamilyData().data[0].familyID
            })
        ]).then((results) => {
            let works = 0;
            if (results[0].status === 200) {
                works++;
            }
            if (results[1][0].status === 200) {
                works++;
            }
            if (results[1][1].status === 200) {
                works++;
            }
            if (works > 0) {
                instance.stop(1);
            } else {
                instance.stop(-1);
            }
            this.$http.get("/api/family/" + this.ApplicationService.getFamilyData().data[0].familyID
                + "/taxLog").then((results) => {
                let familyID = this.ApplicationService.getFamilyData().data[0].familyID;
                let log = results.data[Object.keys(results.data)[0]];
                this.ApplicationService.getFamilyData().taxFileLog[familyID] = log;
            });
        });
    },
    successSave: function(scope, instance, callback) {
        this.SliderService.closeSlider(0);
        if (typeof callback !== "undefined") {
            callback();
        }
    },
    stage: function(element) //stages files for upload
    {   
        var parent = this;
        if (this.$.files==undefined) 
            this.$.files = [];
        for (var i = 0; i < element.files.length; i++) {
            this.$.$apply(function() {
                parent.$.files.push(element.files[i]);
                parent.$.fileinput = {};
            })
        }
    },

    upload: function(index) { // Actually submits the staged file
        this.$.uploadLoading = true;
        let auth = this.authServiceFactory.getAuth();
        let fd = new FormData();
        fd.append("family_id", this.ApplicationService.getFamilyData().data[0].familyID);
        fd.append("document", this.$.files[index]);
        fd.append("client", "school - Beta, uploaded by "
                    + auth.firstName + " "
                    + auth.lastName + " from "
                    + this.$.schoolinfo.School_Name);
        fd.append("purpose", "insert");
        let headers = {
            "auth-token": "2fdc77f3474eba15e868340948ecbf2a4ad1c3e0a37d7cc30566d49eeae38238153c5a26e122c0d7b62927e5b3c008f1",
            "job-user": 1,
            "Content-Type": undefined
        };
        let req = {
            method: "POST",
            url: "https://pdf.ismfast.com/api/PDFProcessingQueue",
            headers: headers,
            data: fd
        };

        let uploadKey = this.$.files[index].name + this.$.files[index].size +  this.$.files[index].lastModified;
        if (this.uploadedFiles.indexOf(uploadKey) === -1) {

            this.$http(req).then((response) => {
                let familyID = this.ApplicationService.getFamilyData().data[0].familyID;
                this.$.files[index].httpStatus = response.status;
                if (response.data.answer === "File transfer completed" ||
                    response.data.answer === "File already uploaded") {

                    this.$.files[index].status = 1;
                    this.$http.get("/api/family/" + familyID + "/taxLog").then((results) => {
                        this.ApplicationService.getFamilyData().taxFileLog[familyID].push(results.data);
                    });
                } else {
                    this.$.files[index].status = 0;
                }
                this.$.checkUploadTotal(index);
            }, (response) => {
                this.$.files[index].httpStatus = response.status;
                this.$.files[index].status = 0;
                this.$.checkUploadTotal(-1);
            });

        } else {
            this.$.checkUploadTotal(-1);
            this.$.files[index].status = 0;
            this.$.files[index].httpStatus = "duplicate";
        }
    },
    checkUploadTotal: function(index){
        this.uploadCount ++;
        if(index >= 0){
            this.uploadedFiles.push(this.$.files[index].name + this.$.files[index].size +  this.$.files[index].lastModified);
        }
        if(this.$.files.length == this.uploadCount){
            this.$.uploadLoading = false;
        }
    },
    uploadAll: function()
    {
        var parent = this;
        this.uploadCount = 0;
        angular.forEach(this.$.files, function(value, key) {
            if (value.status==undefined){
                parent.upload(key, false);
            }else{
                parent.uploadCount ++;
            }
        })
    },
    reset: function()
    {
        this.$.files = [];
    },
    remove: function(index) 
    {
        this.$.files.splice(index, 1);
    },
    getTaxText: function(taxType)
    {
        //Checks to see if a particular year is verified //maybe not necessary
        if (taxType == 1 && this.$.schoolinfo.School_Country=="USA")
            return "Federal";
        else if (taxType == 1 && this.$.schoolinfo.School_Country=="CAN")
            return "T-1 General"
        else if (taxType == 2)
            return "Business";
        else if (taxType == 3 && this.$.schoolinfo.School_Country=="USA")
            return "W2";
        else if (taxType == 3 && this.$.schoolinfo.School_Country=="CAN")
            return "T4";
        else if (taxType == 4 && this.$.schoolinfo.School_Country=="USA")
            return "State";
        else if (taxType == 4 && this.$.schoolinfo.School_Country=="CAN")
            return "Provincial";
        else if (taxType == 5)
            return "Other";
        else
            return taxType;
    },
    returnItem: function($itm)
    {
        return $itm[0].taxYear;
    },
    combine: function(doc, num)
    {
        if (this.$.schoolinfo.School_Country=="USA") { //to account for business taxes
            if (num === 12 && doc[12] === 0) { // if Business is unchecked, unchecked K1 and 1065
                doc[8] = 0;
                doc[9] = 0;
            } else if (num === 12 && doc[12] === 1) { // if Business is checked, check K1 and 1065
                doc[8] = 1;
                doc[9] = 1;
            } else if (doc[8] === 1 || doc[9] === 1) { // if K1 or 1065 is checked, check Business
                doc[12] = 1;
            } else { // otherwise, uncheck business
                doc[12] = 0;
            }
            this.$.documentarray = doc;
        }
        else if (this.$.schoolinfo.School_Country=="CAN") { //to account for T1 and it's supporting schedules
            if ((num==3 && doc[num]==1) || (num==4 && doc[num]==1) || (num==5 && doc[num]==1) 
                || (num==6 && doc[num]==1) || (num==7 && doc[num]==1) || (num==8 && doc[num]==1)) {
                doc[0] = 1;
            }
            else if (num==0 && doc[num]==0) {
                doc[3] = 0;
                doc[4] = 0;
                doc[5] = 0;
                doc[6] = 0;
                doc[7] = 0;
                doc[8] = 0;
            }
            this.$.documentarray = doc;
        }

        var oldNumber = '';
        for (let key in doc) {
            oldNumber += doc[key].toString();
        }
        this.$.family[0].taxDocuments = oldNumber;
        return this.$.family[0].taxDocuments;
    },
    displayEmail: function(note)
    {
        var self = this;
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/taxes/partials/taxEmailModal.html",
            controller: 'TaxEmailModalController',
            resolve: {
                email: function()
                {
                    var model = new self.TaxEmailModelFactory(self.ApplicationService.getFamilyID());
                    return model.resolveData(note.split("-")[1]);
                }
            }
        });
    },
    conversion: function(note)
    {
        if (this.$.schoolinfo.School_Country == "CAN") {
                note = note.replace("Federal", "T1 General")
                            .replace("State", "Provincial")
                            .replace("W2 Tax", "T4 Slips")
                            .replace("W2", "T4 Slips")
                            .replace("Form 1065 or 1120s", "CRA Notice of Assessment");
        }
        return note;
    },
    clickVerification: function(type, priority) {
        this.$.verifyHide = true;
        if (typeof priority == 'undefined') priority = false;
        var parent = this;
        var modal = this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/taxes/partials/verificationModals/"+type+".html",
            controller: 'VerificationModalController',
            resolve: {
                priority: function() {
                    return priority;
                }
            }
        });
        modal.result.catch(function() {
            parent.$.verifyHide = false;
        });
        modal.result.then(function(res) {
            parent.$.verifyHide = false;
            parent.FamilyModelService.resolveData(parent.$.familyNo).then(function() {
                parent.$.separate(parent.$.family[0].taxDocuments);
            });
        });
    },
    separate: function(doc)
    {
        this.$.documentarray = [];
        let sNumber = doc.toString();

        for (var i=0, len=sNumber.length; i < len; i += 1) {
            this.$.documentarray.push(parseInt(+sNumber.charAt(i)));
        }
    },
    docPopup: function(index)
    {
        var parent = this;
        if (index == 1 && this.$.documentarray[index] == 0) {
            var message = "State Tax Forms are used to verify state taxes paid after non-refundable credits are deducted (if applicable). Failure to request this document will prevent verification of state taxes (where state taxes are applicable)."
        }
        else if (index == 2 && this.$.documentarray[index] == 0) {
            var message = "W-2s are used to verify income stated on Line 7 of 1040. Failure to request this document will prevent income verification."
        }
        else if (index == 3 && this.$.documentarray[index] == 0) {
            var message = "Schedule As are used to verify property tax. Failure to request this document will prevent tax verification."
        }
        if (this.$.documentarray[index] == 0) {
            swal({
                    title: "Warning!!",
                    text: message,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD68BB",
                    cancelButtonText: "Do not proceed",
                    confirmButtonText: "Proceed",
                    closeOnConfirm: true
                },
                function(isConfirm) {
                    if (!isConfirm) {
                        parent.$.documentarray[index] = 1;
                        parent.combine(parent.$.documentarray)
                    }
                });
        }
        this.$.documentarray = this.$.documentarray;
    }

});

taxes.filter("currentYear", ["DateService", function(DateService) {
    return function(items, currentYear) {
        var ret = [];
        if (items) {
            items.forEach(function(item, i) {
                if (currentYear && item[0].App_Fin_Year == DateService.getCurrentYear()) {
                    ret.push(item);
                }
                if (currentYear == item[0].App_Fin_Year && item[0].App_Fin_Year < DateService.getCurrentYear())
                    ret.push(item);
            });
        }
        return ret;
    };
}]);

stateProviders.push({
    name: 'schoolside.applications.mainContent.taxes',
    templateUrl: 'fast/submodules/schoolside/applications/mainContent/tabs/taxes/taxes.html?v=' + versionNo,
    controller: 'ApplicationsTaxesController',
    resolve: {
      thresh: function(ModelService, authServiceFactory)
      {
          return ModelService.family.familyTax.resolveData(authServiceFactory.getAuth().schoolID);
      }
    }
});
